var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 27",
    fill: "#008BDA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3272 8.47461H13.9393C12.9502 9.5731 11.5587 10.2789 10.0023 10.3435C8.44595 10.2789 7.05444 9.5731 6.06535 8.47461H5.67747C3.75262 8.47461 2.19141 10.0751 2.19141 12.0484V21.4328C2.29807 22.7351 2.77807 24.7233 4.63504 25.6876C6.29322 26.3884 8.10171 26.7911 9.99747 26.8209H10.0023H10.0072C11.9029 26.7911 13.7114 26.3884 15.3696 25.6876C17.2266 24.7233 17.7066 22.7351 17.8132 21.4328V12.0435C17.8132 10.0702 16.252 8.47461 14.3272 8.47461Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0023 9.10585C12.4149 9.10585 14.3708 7.10077 14.3708 4.62739C14.3708 2.154 12.4149 0.148926 10.0023 0.148926C7.58963 0.148926 5.63379 2.154 5.63379 4.62739C5.63379 7.10077 7.58963 9.10585 10.0023 9.10585Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubman);
export default __webpack_public_path__ + "static/media/hubman.108e53d7.svg";
export { ForwardRef as ReactComponent };